<template>
  <div :class="classObj" class="layout-main">
    <div class="navtopo" :class="sidebarStatus ? '' : inactivenavbar">
      <nav-bar />
    </div>
    <sidebar />
    <div class="lm-content-area" :class="sidebarStatus ? activebar : inactivebar">
      <app-main class="main-content" />
    </div>
  </div>
</template>

<script>
import AppMain from './components/AppMain';
import NavBar from './components/navbar';
import Sidebar from './components/sidebar/index';

export default {
	components: {
		AppMain,
		NavBar,
		Sidebar,
	},
	data() {
		return {
			activebar: 'activebar',
			inactivebar: 'inactivebar',
			inactivenavbar: 'inactivenavbar',
		};
	},
	computed: {
		classObj() {
			return {
				hideSidebar: false,
			};
		},
		sidebarStatus() {
			return this.$store.getters.getBarStatus;
		},
	},
	methods: {
		addNewData() {},
	},
};
</script>

<style lang="scss" scoped>
.layout-main {
	flex-direction: row;
	flex: 1;
	.lm-content-area {
		flex: 1;
		display: flex;
		flex-direction: column;
		transition: 0.3s ease-in;
	}
}

@media screen and (min-device-width: 300px) and (max-device-width: 1366px) {
	.activebar {
		padding-left: 20%;
	}
	.inactivebar {
		padding-left: 6%;
	}
	.navtopo {
		width: 77%;
	}
	.inactivenavbar {
		width: 91.2%;
	}
}
@media screen and (min-device-width: 1367px) and (max-device-width: 3000px) {
	.activebar {
		padding-left: 280px;
	}
	.inactivebar {
		padding-left: 4%;
	}
	.navtopo {
		width: calc(100% - 320px);
	}
	.inactivenavbar {
		width: 93.8%;
	}
}

.navtopo {
	/*   background-color: hsl(223, 54%, 95%); */
	background: linear-gradient(
		180deg,
		hsla(223, 54%, 95%, 0.95) 44%,
		hsla(223, 54%, 95%, 0.46) 73%,
		hsla(0, 0%, 100%, 0)
	);
	position: fixed;
	height: 50px;
	z-index: 98;
	transition: 0.3s ease-in;
	right: 0;
	margin: 0rem 1.25rem 0;
	padding-top: 1rem;
}

.main-content {
	margin-top: 100px;
}
</style>
